<div class="row">
  @if (!show.advancedSearch) {
    <div class="col-12 col-md-8">
      <nsc-form-field-select
        idx="recepientselect_org"
        controlName="organization"
        placeholder="Select Organization"
        [group]="formGroup"
      [selectObjects]="values.organizations$.value"></nsc-form-field-select>
    </div>
  }
  @if (show.advancedSearch) {
    <div class="col-12 col-md-8">
      <nsc-form-field-autocomplete idx="recepientselectorgautocomplete" controlName="organization"
        placeholder="Enter a keyword to find and select the organization you are sending your transcript to"
        [group]="formGroup" [notInList]="true" [searchType]="values.searchType"
        [options]="values.organizations$.value"
        [minCharactersToTrigger]="values.minCharactersToTrigger">
      </nsc-form-field-autocomplete>
    </div>
  }
  <div class="col-12 ">
    <button 
        mat-raised-button 
        id="organization_search_button" 
        class="nsc-form-actions__button nsc-btn__right button-big" 
        color="primary"
        type="button" 
        (click)="searchLinkAction($event)">
          {{values.searchLinkLabel}}
    </button>
  </div>
  @if (formGroup.controls['organizationNotInList'].enabled) {
    <div class="col-12">
      <nsc-spacer size="sm"></nsc-spacer>
    </div>
  }
  @if (formGroup.controls['organizationNotInList'].enabled) {
    <div class="col-12 col-md-8">
      <nsc-form-field-input
        idx="recepientselect_orgnotinlist"
        controlName="organizationNotInList"
        maxlength="60"
        placeholder="Enter an Organization"
      [group]="formGroup"></nsc-form-field-input>
    </div>
  }
  @if (!values.isEnrolledBefore) {
    <div class="col-12">
      <nsc-spacer size="sm"></nsc-spacer>
    </div>
  }
  @if (!values.isEnrolledBefore) {
    <nsc-recipient-select-department
      class="col-12"
    [formGroup]="formGroup"></nsc-recipient-select-department>
  }
</div>
